import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentProductos } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StoreService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<any>(`${environmentProductos.apiUrl}/Store/Get`);
    }
    
    deleteStoreID(id) {
        return this.http.post<any>(`${environmentProductos.apiUrl}/StoreProduct/Disabled`,id);
    }

    insertStore(json) {
        console.log("en insert ",json);
        return this.http.post<any>(`${environmentProductos.apiUrl}/Store/InsertOrUpdate`,json );
    }

    insertStoreProductID(json){
        return this.http.post<any>(`${environmentProductos.apiUrl}/StoreProduct/InsertOrUpdate`,json );
    }

}